var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.gpsData)?_c('div',{staticClass:"map"},[_c('img',{staticClass:"no-gps",attrs:{"name":"info","src":require(("@/assets/share/sportIcon/" + _vm.sportType + ".png"))}})]):_vm._e(),_vm._v(" "),(_vm.gpsData)?_c('canvas',{staticClass:"map",attrs:{"width":"56","height":"56","id":_vm.canvasId}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efc03f56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gpsBaidu.vue
// module id = null
// module chunks = 